import { useState, useEffect } from "react";
import stateFormats from "../../constants/state-formats";
import getCities from "../../services/getCities";
export default function useBRCityWidget(_ref) {
  var payload = _ref.payload,
    modifyPayloadKeys = _ref.modifyPayloadKeys,
    stateFieldSlug = _ref.stateFieldSlug,
    _ref$stateFormat = _ref.stateFormat,
    stateFormat = _ref$stateFormat === void 0 ? "br" : _ref$stateFormat,
    slug = _ref.slug;
  var _useState = useState([]),
    options = _useState[0],
    setOptions = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsloading = _useState2[1];
  var provinceValue = payload === null || payload === void 0 ? void 0 : payload[stateFieldSlug];
  useEffect(_handleStateChange, [provinceValue]);
  function _handleStateChange() {
    var _stateFormats$correct;
    var correctStateKey = Object.keys(stateFormats).find(function (key) {
      var _stateFormats$key;
      return (stateFormats === null || stateFormats === void 0 ? void 0 : (_stateFormats$key = stateFormats[key]) === null || _stateFormats$key === void 0 ? void 0 : _stateFormats$key[stateFormat]) === provinceValue;
    });
    var correctStateNumber = stateFormats === null || stateFormats === void 0 ? void 0 : (_stateFormats$correct = stateFormats[correctStateKey]) === null || _stateFormats$correct === void 0 ? void 0 : _stateFormats$correct.uf;
    if (correctStateNumber) {
      setIsloading(true);
      getCities(correctStateNumber).then(function (res) {
        var _res;
        if (res === void 0) {
          res = [];
        }
        var formatted = (_res = res) === null || _res === void 0 ? void 0 : _res.map(function (item) {
          return {
            label: item === null || item === void 0 ? void 0 : item.nome,
            value: item === null || item === void 0 ? void 0 : item.nome
          };
        });
        setIsloading(false);
        setOptions(formatted);
      });
    }
  }
  return {
    options: options,
    isLoading: isLoading
  };
}